import { EstudianteActivoT } from "../SAAC/EstudianteActivo"
import { PeriodoAcademico } from "../SAAC/PeriodoAcademico"
import { SolicitudAyudanteInv } from "./SolicitudAyud"
import { TblDecInvProyectoAyud, VoidTblDecInvProyectoAyud } from "./TblDecInvProyectoAyud"
import { TblDetalleSolicitudAyud, VoidTblDetalleSolicitudAyud } from "./TblDetalleSolicitudAyud"
import { TblGestionSolicitudAyud } from "./TblGestionSolicitudAyud"
import { TblSolicitudAyud, VoidTblSolicitudAyud } from "./TblSolicitudAyud"

export interface Ayudantia{
    idayudantia: number,
    nombreproyecto: string,
    nombreayudante: string,
    matricula: string,
    nombreInvestigador: string,
    fechaSolicitud: Date,
    estado: string,
    estudianteCumple: string
    horas: number
}


export interface AyudantiaInvestigacion{
    codigoProyecto: string,
    tituloProyecto: string,
    estudiante: string,
    proyectoAyud: TblDecInvProyectoAyud,
    solicitudAyudCab: TblSolicitudAyud,
    detalle: TblDetalleSolicitudAyud,
    gestion: Array<TblGestionSolicitudAyud>,
}

export interface PlanificacionAyudantia{
    horasPlanificadasTotales : number,
    horasOtorgadasEspol : Number,
    horasOtorgadasProyecto : number,
    horasOtorgadasAdHonorem : number,
    horasRestantes : number
}

export function VoidPlanificacionAyudantia(): PlanificacionAyudantia{
    return{
        horasPlanificadasTotales : 0,
        horasOtorgadasEspol : 0,
        horasOtorgadasProyecto : 0,
        horasOtorgadasAdHonorem : 0,
        horasRestantes : 0
    }
    
}

// public class PlanificacionAyudantia : IEntity
// {
//     public int horasPlanificadasTotales { get; set; }
//     public int horasOtorgadasEspol { get; set; }
//     public int horasOtorgadasProyecto { get; set; }
//     public int horasOtorgadasAdHonorem { get; set; }
//     public int horasRestantes { get; set; }
// }

export function VoidAyudantiaInvestigacion(): AyudantiaInvestigacion{
    return{
        codigoProyecto: '',
        tituloProyecto: '',
        estudiante: '',
        proyectoAyud: VoidTblDecInvProyectoAyud(),
        solicitudAyudCab: VoidTblSolicitudAyud(),
        detalle: VoidTblDetalleSolicitudAyud(),
        gestion: [],
    }   
}

export function CastTblDecInvProyectoAyud (tbldecinvproyectoayud: TblDecInvProyectoAyud,values: SolicitudAyudanteInv): TblDecInvProyectoAyud{
   
    tbldecinvproyectoayud.descripcion = values.descripcion;
    tbldecinvproyectoayud.iddecinvproyectoayud = tbldecinvproyectoayud.iddecinvproyectoayud;
    tbldecinvproyectoayud.horas = parseInt(values.horas ?? '0', 10);
    tbldecinvproyectoayud.actividades = values.actividades;
 
    tbldecinvproyectoayud.financiamientoayudante = parseInt(values.tipofinanciamiento?? '0', 10);
    tbldecinvproyectoayud.mailresponsable = values.docente;


    return tbldecinvproyectoayud;
}


export function CastSolicitudAyudanteInvToAyudantiaInvestigacion(ayudantia: AyudantiaInvestigacion,values: SolicitudAyudanteInv,periodo: PeriodoAcademico,idproyecto: number,estudiante: EstudianteActivoT):AyudantiaInvestigacion{
    let objeto = ayudantia;

    objeto.proyectoAyud.iddecinvproyecto = idproyecto;
    objeto.proyectoAyud.codEstudiante = estudiante.matricula;
    objeto.proyectoAyud.descripcion = values.descripcion;
    objeto.proyectoAyud.termino = periodo.termino;
    objeto.proyectoAyud.anio = periodo.anio;
    objeto.proyectoAyud.horas = parseInt(values.horas ?? '0', 10);
    objeto.proyectoAyud.actividades = values.actividades;
    objeto.proyectoAyud.estado = 'R';    
    objeto.proyectoAyud.financiamientoayudante = parseInt(values.tipofinanciamiento?? '0', 10);
    objeto.proyectoAyud.mailresponsable = values.docente;
    objeto.proyectoAyud.ultimoCambio = undefined ;
    objeto.proyectoAyud.fechasolicitud = undefined;

    objeto.solicitudAyudCab.idperiodo = periodo.idperiodo;
    objeto.solicitudAyudCab.idestudiante = estudiante.idpersona;
    objeto.solicitudAyudCab.codestudiante = estudiante.matricula;
    objeto.solicitudAyudCab.observacion = 'Generado desde el sistema de ayudantías 2025';
    objeto.solicitudAyudCab.tipo = 'I';
    objeto.solicitudAyudCab.estado = 'A';
    objeto.solicitudAyudCab.limitehoraayud = parseInt(values.horas ?? '0', 10);
    objeto.solicitudAyudCab.esadhonorem = objeto.proyectoAyud.financiamientoayudante === 2 ? 'S' : 'N';
    objeto.solicitudAyudCab.ultimoCambio= undefined;
    objeto.solicitudAyudCab.fechasolicitud = undefined;
    
    objeto.detalle.idunidad = 15267;
    objeto.detalle.numhoras = parseInt(values.horas ?? '0', 10);
    objeto.detalle.tipo = 'I';
    objeto.detalle.estado = 'P';
    objeto.detalle.numayudantias = objeto.detalle.numhoras === 5 ? 1 : 2;
    objeto.detalle.numayudantiasotorgadas = 0;
    objeto.detalle.numhorasotorgadas = 0;
    objeto.detalle.esadhonorem = objeto.proyectoAyud.financiamientoayudante === 2 ? 'S' : 'N';
    objeto.detalle.ultimoCambio = undefined;
  
    //console.log(objeto);
    return objeto;
}


export interface AyudantiaInvestigacionData {
    idproyecto: number;
    idayudantiaproyecto: number;
    iddetallesolicitud: number;
    idsolicitudayudantia: number;
    idperiodo: number;
    nombreProyecto: string;
    tipo: string;
    nombreEstudiante: string;
    codestudiante: string;
    financiamientoTexto: string;
    fechasolicitud: string;
    horas: number;
    horasOtorgadas: number;
    anio: string;
    termino: string;
    descripcion: string;
    actividades: string;
    tipoFinanciamiento: number;
    emailResponsable: string;
    nombreInvestigador: string;
    comentario: string;
    estadoDelegado: string;
    estadoSubdecano: string;
    estadoVicerrectorado: string;
    estadoPaso: string;
    estudianteImpedimentos: string;
}

export function voidAyudantiaInvestigacionData(): AyudantiaInvestigacionData {
    return {
        idproyecto: 0,
        idayudantiaproyecto: 0,
        iddetallesolicitud: 0,
        idsolicitudayudantia: 0,
        idperiodo: 0,
        nombreProyecto: '',
        tipo: '',
        nombreEstudiante: '',
        codestudiante: '',
        financiamientoTexto: '',
        fechasolicitud: '',
        horas: 0,
        horasOtorgadas: 0,
        anio: '',
        termino: '',
        descripcion: '',
        actividades: '',
        tipoFinanciamiento: 0,
        emailResponsable: '',
        nombreInvestigador: '',
        comentario: '',
        estadoDelegado: '',
        estadoSubdecano: '',
        estadoVicerrectorado: '',
        estadoPaso: '',
        estudianteImpedimentos: ''
    };
}

export interface solicitudAprobacionDTO {
    iddetallesolicitud : number,
    horasAprobadas: number,
    CodEstudiante: string,
    observacion: string
}

export function VoidSolicitudAprobacionDTO() : solicitudAprobacionDTO{
    return {
        iddetallesolicitud : 0,
        horasAprobadas: 0,
        CodEstudiante: '',
        observacion: ''
    };
}

export function CastSolicitudAyudantiaDTO(horas: string, observacion: string, matricula: string, iddetalle: number ):solicitudAprobacionDTO{
    let obj = VoidSolicitudAprobacionDTO();
    obj.iddetallesolicitud = iddetalle;
    obj.CodEstudiante = matricula;
    obj.horasAprobadas = parseInt(horas,10);
    if(observacion!==''){
        obj.observacion = observacion;
    }
    return obj;
}

export interface ResponseAprobacion {
    codestudiante : string,
    nombreEstudiante: string,
    impedimentos: string
}

export function CastSolicitudAyudantiaRechazo(solicitudes: Array<AyudantiaInvestigacionData>, comentario: string): Array<solicitudAprobacionDTO>{
    let solicitudesRechazo:solicitudAprobacionDTO [] = [];
    solicitudes.forEach(
        solicitud =>{
            let obj = VoidSolicitudAprobacionDTO();
            obj.iddetallesolicitud = solicitud.iddetallesolicitud;
            obj.CodEstudiante = solicitud.codestudiante;
            obj.horasAprobadas = solicitud.horas;
            obj.observacion = comentario;
            solicitudesRechazo.push(obj);
        }
    )
    return solicitudesRechazo;
}

export function CastSolicitudesAyudantiasDTO(solicitudes: Array<AyudantiaInvestigacionData>, observacion: string):Array<solicitudAprobacionDTO>{
    let solicitudesAprobadas:solicitudAprobacionDTO [] = [];

    solicitudes.forEach(
        solicitud =>{
            let obj = VoidSolicitudAprobacionDTO();
            obj.iddetallesolicitud = solicitud.iddetallesolicitud;
            obj.CodEstudiante = solicitud.codestudiante;
            obj.horasAprobadas = solicitud.horasOtorgadas;
            if(observacion!==''){
                obj.observacion = observacion;
            }
            solicitudesAprobadas.push(obj);
        }
    )
    
    return solicitudesAprobadas;
}